import Nullstack from 'nullstack';
export default function IconWindOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-wind-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M5 8h3m4 0h1.5a2.5 2.5 0 1 0 -2.34 -3.24"
  }), "   ", Nullstack.element("path", {
    d: "M3 12h9"
  }), "   ", Nullstack.element("path", {
    d: "M16 12h2.5a2.5 2.5 0 0 1 1.801 4.282"
  }), "   ", Nullstack.element("path", {
    d: "M4 16h5.5a2.5 2.5 0 1 1 -2.34 3.24"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}